import * as React from "react";
const SvgFiRrCustomerCare = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-customer-care_svg__a)">
      <path
        fill="#062147"
        d="M11 2a2 2 0 1 1 3.999-.001A2 2 0 0 1 11 2m.942 3A3.49 3.49 0 0 1 13 7.5V8h2.407c.37 0 .665-.344.578-.704A3 3 0 0 0 13.068 5zM8 5a2 2 0 1 0 .001-3.999A2 2 0 0 0 8 5M.593 8H3v-.5c0-.98.407-1.864 1.058-2.5H2.932c-1.414 0-2.6.979-2.917 2.296-.087.36.208.704.578.704m22.642 5.015-6.804 7.637A10 10 0 0 1 8.964 24H3.999c-2.206 0-4-1.794-4-4v-5c0-2.206 1.794-4 4-4h8.857a3.14 3.14 0 0 1 2.689 1.519l3.217-3.534a2.98 2.98 0 0 1 2.085-.981 2.97 2.97 0 0 1 2.169.782 3.02 3.02 0 0 1 .218 4.23zm-1.565-2.752a1.03 1.03 0 0 0-.728-.262 1 1 0 0 0-.699.329l-4.427 4.865a3.16 3.16 0 0 1-2.514 2.058l-5.161.737a1 1 0 1 1-.283-1.979l5.161-.737c.559-.08.98-.566.98-1.131 0-.63-.513-1.142-1.143-1.142H4c-1.103 0-2 .897-2 2v5c0 1.103.897 2 2 2h4.965a8 8 0 0 0 5.973-2.678l6.805-7.638a1.015 1.015 0 0 0-.072-1.421zM5.607 9h4.786c.379 0 .68-.344.591-.704C10.66 6.979 9.447 6 8 6s-2.66.979-2.984 2.296c-.089.36.213.704.591.704M3 4A2 2 0 1 0 3.001.001 2 2 0 0 0 3 4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-customer-care_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCustomerCare;
